import { Translation } from '@ps/web-shared-components';
import { format } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { minLength, numbersOnly, required } from '@swf/core/utils/validators';
import type { Error } from '@swf/core/utils/validators';

import CNPIcon from '../../../../../../assets/icons/cnp.svg';
import InfoPrompt from '../../../../../InfoPrompt/InfoPrompt';
import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTCLI_Info,
  TXTWCL_CNP,
  TXTWCL_Ensure_your_CNP_matches_your_d_ELL,
  TXTWCL_Whole_numbers_onlyX_No_decimal_ELL,
  TXTWCL_Your_CNP_must_be_13_digitsX,
  TXTWCL_Your_CNP_number_is_found_on_yo_ELL,
  TXTWCL_Your_date_of_birth_and_CNP_mus_ELL
} from './CNP.messages.json';
import { infoPrompt, labelContent } from './CNP.scss';

const validateCNP =
  (dob?: Date, message?: Error['message']) =>
  (value: string): Error => ({
    valid: value?.substring(1, 7) === format(new Date(dob as Date), 'yyMMdd'),
    message
  });

const CNP: React.FC = () => {
  const dob = useSelector(select.account.getDateOfBirth);

  return (
    // field has missing property "checkDisabled" because of problem described in PAMT-25470
    <TextInput
      id="nationalDocumentNumber"
      maxLength={13}
      label={TXTWCL_CNP}
      labelClassName={labelContent}
      labelContent={
        <InfoPrompt title={{ translation: TXTCLI_Info }}>
          <div className={infoPrompt}>
            <p>
              <Translation {...TXTWCL_Your_CNP_number_is_found_on_yo_ELL} />{' '}
              <Translation {...TXTWCL_Your_date_of_birth_and_CNP_mus_ELL} />
            </p>
            <CNPIcon />
          </div>
        </InfoPrompt>
      }
      validators={[
        required(null),
        numbersOnly(TXTWCL_Whole_numbers_onlyX_No_decimal_ELL),
        minLength(13, TXTWCL_Your_CNP_must_be_13_digitsX),
        validateCNP(dob, TXTWCL_Ensure_your_CNP_matches_your_d_ELL)
      ]}
    />
  );
};

export default CNP;
